import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ReportCategoryMapping {
    id: string;
    report_id: string;
    category: string;
    report_name: string | null;
    created_at: string;
}

export interface CreateReportCategoryRequest {
    reportId: string;
    category: string;
    reportName?: string;
}

export interface ApiResponse<T> {
    success: boolean;
    data?: T;
    message?: string;
    timestamp: string;
}

@Injectable({
    providedIn: 'root',
})
export class ReportCategoryService {
    private apiUrl = `${environment.apiUrl}/v1/powerbi`;

    constructor(
        // eslint-disable-next-line no-unused-vars
        private http: HttpClient
    ) {}

    getMappings(): Observable<ApiResponse<ReportCategoryMapping[]>> {
        return this.http.get<ApiResponse<ReportCategoryMapping[]>>(
            `${this.apiUrl}/report-categories`,
            { headers: this.getAuthHeaders() }
        );
    }

    createMapping(
        data: CreateReportCategoryRequest
    ): Observable<ApiResponse<void>> {
        return this.http.post<ApiResponse<void>>(
            `${this.apiUrl}/report-categories`,
            data,
            { headers: this.getAuthHeaders() }
        );
    }

    deleteMapping(id: string): Observable<ApiResponse<void>> {
        return this.http.delete<ApiResponse<void>>(
            `${this.apiUrl}/report-categories/${id}`,
            { headers: this.getAuthHeaders() }
        );
    }

    private getAuthToken(): string | null {
        return localStorage.getItem('access_token');
    }

    private getAuthHeaders(): HttpHeaders {
        const token = this.getAuthToken();
        return new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        });
    }
}
